import { Avatar, Box, Menu, Portal } from '@chakra-ui/react';
import { FiLogOut } from 'react-icons/fi';

type UserMenuProps = {
    user: any;
    handleLogout: () => Promise<void>;
};

export function UserMenu({ user, handleLogout }: UserMenuProps) {
    if (!user) return null;

    return (
        <Menu.Root>
            <Menu.Trigger>
                <Avatar.Root
                    size="sm"
                    shape="rounded"
                    cursor="pointer"
                    role="button"
                    aria-haspopup="menu"
                    _hover={{ bg: 'gray.100' }}
                >
                    <Avatar.Image
                        src={user?.photoURL ?? undefined}
                        alt={user?.displayName ?? user?.email ?? 'NN'}
                        objectFit="cover"
                    />
                    <Avatar.Fallback name={user?.displayName ?? user?.email ?? 'NN'} />
                </Avatar.Root>
            </Menu.Trigger>
            <Portal>
                <Menu.Positioner>
                    <Menu.Content>
                        <Box px="3" py="2" fontSize="sm" fontWeight="bold" color="gray.500" userSelect="none" >
                            {user?.displayName || user?.email || 'Użytkownik'}
                        </Box>
                        <Menu.Item onSelect={handleLogout} value="logout">
                            <FiLogOut />
                            <Box>Wyloguj</Box>
                        </Menu.Item>
                    </Menu.Content>
                </Menu.Positioner>
            </Portal>
        </Menu.Root>
    );
}
